$('#SelectedVariantId').on('change', function () {
    variantIdChanged();
});

document.addEventListener('DOMContentLoaded', function () {
    variantIdChanged();
});

function variantIdChanged() {
    const variantEles = document.getElementsByName('id');

    if (!variantEles || variantEles.length === 0) {
        return;
    }

    const variantId = variantEles[0].value;
    const productJsonNode = document.querySelector('#CurrentProductJson');

    if (!productJsonNode) {
        return;
    }

    const product = JSON.parse(productJsonNode.innerHTML);
    const variants = product.variants;
    const currentVariant = variants.find(variant => variant.id == variantId);
    changeVariantDescriptions(variants, variantId);
    hideNonVariantImages(currentVariant, variants, product);
    changeProgressBar(variantId);
}


/* Die Galerie zeigt nur die Medien der gewählten Variante. Zwei Wege, in dieser
   Reihenfolge:

   1. Über das Design-Tag im Alt-Text (|p:<id>|), das die Weltmaschine mitliefert.
      Das ist eine echte Zuordnung und funktioniert auch dann, wenn Shopify der
      Variante kein Bild zugewiesen hat.
   2. Sonst über die Medien-Reihenfolge ab dem Variantenbild - der alte Weg, für
      Produkte ohne Design-Tag.

   Bleibt beides ohne Treffer, wird nicht gefiltert: lieber alle Bilder als die
   falschen. */
function hideNonVariantImages(currentVariant, variants, product) {
    const mediaIds = getVariantMediaIdsByDesignTag(currentVariant, product)
        || getVariantMediaIdsByOrder(currentVariant, variants);

    applyVisibleMediaIds(mediaIds);
}

function getVariantMediaIdsByDesignTag(currentVariant, product) {
    const designId = getVariantDesignId(currentVariant);
    if (!designId || !product || !product.media) {
        return null;
    }

    const mediaIds = product.media
        .filter(media => extractDesignId(media.alt) === designId)
        .map(media => String(media.id));

    return mediaIds.length > 0 ? mediaIds : null;
}

/* Das Bild der Variante trägt das Design-Tag, aber nur wenn Shopify eines
   zugewiesen hat. Die SKU (PD-1725155-STANDARD) trägt dieselbe Design-Id und ist
   immer da - deshalb als zweite Quelle. */
function getVariantDesignId(variant) {
    if (!variant) {
        return null;
    }

    const fromAlt = extractDesignId(variant.featured_media && variant.featured_media.alt);
    if (fromAlt) {
        return fromAlt;
    }

    const fromSku = /(?:^|-)(\d+)(?:-|$)/.exec(variant.sku || '');
    return fromSku ? fromSku[1] : null;
}

/* Spiegelt ShopifyImageAltHelper der Weltmaschine. Der Titel davor und der Hash
   dahinter sind beide optional, es gibt also "Titel|p:1|h:x", "Titel|p:1",
   "p:1|h:x" und "p:1" - dazu den Sonderfall, dass der Alt-Text nur die Id ist. */
function extractDesignId(alt) {
    const value = (alt || '').trim();
    if (/^\d+$/.test(value)) {
        return value;
    }

    const match = /(?:^|\|)p:(\d+)(?:\||$)/.exec(value);
    return match ? match[1] : null;
}

function getVariantMediaIdsByOrder(currentVariant, variants) {
    if (!currentVariant || !currentVariant.featured_media) {
        return null;
    }

    const relevantImageArray = getImageElements();
    const variantImageTag = currentVariant.featured_media.id;
    const variantDataMediaIdEles = [];
    for (const relevantImages of relevantImageArray) {
        let firstVariantImageFound = false;
        for (const dataMediaIdEle of relevantImages) {
            const dataMediaId = dataMediaIdEle.getAttribute('data-media-id');
            if (dataMediaId.includes('template')) {
                continue
            }
            let currentVariantLinksToImage = false;
            if (variantImageTag == dataMediaId) {
                currentVariantLinksToImage = true;
                firstVariantImageFound = true
            }
            let otherVariantLinksToImage = false;
            for (const variant of variants) {
                if (!variant || !variant.featured_media) {
                    continue
                }
                if (variant.id == currentVariant.id) {
                    continue
                }
                if (variant.featured_media.id == dataMediaId) {
                    otherVariantLinksToImage = true
                }
            }
            if (!firstVariantImageFound) {
                continue
            }
            if (firstVariantImageFound && (currentVariantLinksToImage || !otherVariantLinksToImage)) {
                variantDataMediaIdEles.push(dataMediaIdEle)
            } else if (firstVariantImageFound && otherVariantLinksToImage) {
                break
            }
        }
    }

    const mediaIds = variantDataMediaIdEles.map(ele => ele.getAttribute('data-media-id'));
    return mediaIds.length > 0 ? mediaIds : null;
}

function applyVisibleMediaIds(visibleMediaIds) {
    filterVariantThumbnails(visibleMediaIds);
    filterVariantSlides(visibleMediaIds);
}

function filterVariantSlides(visibleMediaIds) {
    const $slider = $('.product-detail__images');
    if (!$slider.hasClass('slick-initialized')) {
        return
    }
    $slider.slick('slickUnfilter');
    renumberSlides($slider);
    if (!visibleMediaIds || visibleMediaIds.length === 0) {
        return
    }
    $slider.slick('slickFilter', function () {
        return visibleMediaIds.includes($(this).find('[data-media-id]').attr('data-media-id'))
    });
    renumberSlides($slider);
    $slider.slick('slickGoTo', 0, true);
}

/* slickFilter entfernt Slides, nummeriert die verbleibenden aber nicht neu. Der
   Klick auf ein Thumbnail springt in der Stock-theme.js über data-slick-index
   (_updatePrimaryProductMediaFromThumbnail), das dann zu hoch ist und slick auf
   den letzten Slide klemmt. Nur die erste Variante blieb heil, weil ihre Medien
   bei 0 anfangen. jQuery cached .data(), deshalb muss beides gesetzt werden. */
function renumberSlides($slider) {
    $slider.find('.slick-slide:not(.slick-cloned)').each(function (index, element) {
        $(element).attr('data-slick-index', index).data('slick-index', index);
    });
}

/* Die Vorschauleiste (mobil sichtbar, siehe panda-custom.css) muss dieselben
   Medien zeigen wie der gefilterte Slider - sonst zeigt ein Thumbnail auf
   einen Slide, den es nicht mehr gibt. */
function filterVariantThumbnails(visibleMediaIds) {
    const thumbnails = document.querySelectorAll('[data-product-media-thumbnail]');
    thumbnails.forEach(thumb => {
        const visible = !visibleMediaIds || visibleMediaIds.length === 0 ||
            visibleMediaIds.includes(thumb.getAttribute('data-media-id'));
        thumb.style.display = visible ? '' : 'none';
    });
}

function getImageElements() {
    const relevantDesktopImages = [];
    const desktopThumbs = document.getElementsByClassName('product-detail__thumbnail');
    for (const desktopThumb of desktopThumbs) {
        relevantDesktopImages.push(desktopThumb)
    }
    return [relevantDesktopImages]
}

function changeVariantDescriptions(variants, variantId) {
    const divs = $("div[id^=div_tab_]");
    const variantDivs = $("div[id^=variant_div_]");

    const mergedDivs = divs.toArray().concat(variantDivs.toArray());

    variants.forEach(function (variant) {
        for (const div of mergedDivs) {
            if (div.id.includes(variant.id)) {
                if (variant.id == variantId) {
                    div.style.display = 'block'
                } else {
                    div.style.display = 'none'
                }
            }
        }
    })
}

function changeProgressBar(variantId) {
    $('.variant-progress').each(function () {
        if ($(this).attr('data-variant-id') == variantId) {
            $(this).show()
        } else {
            $(this).hide()
        }
    })
}
